// fr.gestionpial.user.services.SecondFactorAdminServiceI generated by ic2 no-version-available at Thu Oct 01 15:16:26 UTC 2026
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IRPC, JSONSerializer, JSONRpcRequest, JSONRpcResponse, RpcRequestBuilder } from '@ic2/ic2-lib';

@Injectable({
  providedIn: 'root',
})
export class SecondFactorAdminService {
  private irpc = inject(IRPC);

  resetSecondFactor = (idUser: number): RpcRequestBuilder<void> => {
    const req = new JSONRpcRequest();
    req.method = 'SecondFactorAdminService.resetSecondFactor';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(idUser, 'java.lang.Integer', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, null);
  };

}
